import { setCurrencyFormat } from 'src/utils/util';
import {
    checkIfValidQuantities,
    getTotalExtendedPrice,
    getTotalQuantity,
} from './eventHandlerUtil';
import { numFormatObj } from 'src/utils/util';
import i18n from 'src/i18n.js';

const t = (key) => i18n.t(key);

export const invalidProductMsg = t(
    'productValidationMessages.invalidProductMsg'
);
export const invalidBundleItemMsg = t(
    'productValidationMessages.invalidBundleItemMsg'
);
export const invalidSPSitemMsg = t(
    'productValidationMessages.invalidSPSitemMsg'
);
export const emptyBundleMsg = t('reportUsage.itemTableErrorMessages.Bundle');

export const getUniqueKey = () => {
    return new Date().getTime();
};

export const getModifiedProcedureResponse = (procedureData) => {
    return Object.fromEntries(
        Object.entries(procedureData).map((entry) => [
            entry[0],
            entry[1] instanceof Array
                ? entry[1].map((x) => ({
                      ...x,
                      description:
                          x.description === 'MazorX Robot Used'
                              ? t('equity.common.utils.mazorX')
                              : x.description,
                      isSelected: null,
                  }))
                : entry[1],
        ])
    );
};

export const getModifiedBundleChildItems = (
    existingItem,
    pricedItemsArr,
    bundleHeadersArr
) => {
    return existingItem.children.map((child) => {
        let updatedChildItemObj = { ...child };
        const pricedChildItemIdx = pricedItemsArr
            .map((x) => x.productCFN)
            .findIndex((y) => y === child.cfn);
        if (pricedChildItemIdx >= 0) {
            updatedChildItemObj = {
                ...pricedItemsArr[pricedChildItemIdx],
                cfn: child.cfn,
                lotSerial: child.lotSerial,
                salesOrg: pricedItemsArr[pricedChildItemIdx].salesOrg,
            };
            updatedChildItemObj.basePrice = null;
            if (pricedItemsArr[pricedChildItemIdx].salesOrg === 'S030') {
                updatedChildItemObj.isInvalidItemMsg = t(
                    'equity.common.utils.tissueItems'
                );
            } else if (
                pricedItemsArr[pricedChildItemIdx].exclusionStatus ===
                'Item number not found.'
            ) {
                updatedChildItemObj.isInvalidItemMsg = invalidProductMsg;
            } else if (pricedItemsArr[pricedChildItemIdx].isSet) {
                updatedChildItemObj.isInvalidItemMsg = t(
                    'equity.common.utils.setsNotAllowed'
                );
            } else if (pricedItemsArr[pricedChildItemIdx].exclusionStatus) {
                updatedChildItemObj.isInvalidItemMsg =
                    pricedItemsArr[pricedChildItemIdx].exclusionStatus;
            } else {
                updatedChildItemObj.isInvalidItemMsg = null;
            }
        } else if (bundleHeadersArr.includes(child.cfn)) {
            updatedChildItemObj.isInvalidItemMsg = t(
                'equity.common.utils.bundleItem'
            );
        } else if (child.cfn.toUpperCase().startsWith('SPS')) {
            updatedChildItemObj.isInvalidItemMsg = invalidSPSitemMsg;
        } else {
            updatedChildItemObj.isInvalidItemMsg = invalidProductMsg;
        }
        return updatedChildItemObj;
    });
};

export const getModifiedItemTableData = (
    existingItemsArr,
    pricedItemsArr,
    bundleHeadersArr,
    isFromReportScreen,
    deliveredUnidRodItems
) => {
    return existingItemsArr.map((existingItem) => {
        let updatedItemObj = { ...existingItem };
        if (
            isFromReportScreen &&
            existingItem.isAdditionalCartEntry &&
            (existingItem.cfn.toUpperCase().startsWith('M2') ||
                existingItem.cfn.toUpperCase().startsWith('M1') ||
                existingItem.cfn.toUpperCase().startsWith('BUN') ||
                existingItem.cfn.toUpperCase().startsWith('KEN')) &&
            bundleHeadersArr.includes(existingItem.cfn.toUpperCase())
        ) {
            updatedItemObj.isInvalidItemMsg = t(
                'equity.common.utils.bundleAdded'
            );
        } else {
            const pricedItemIdx = pricedItemsArr
                .map((x) => x.productCFN)
                .findIndex((y) => y === existingItem.cfn);
            const unidItem = deliveredUnidRodItems?.filter(
                (uItem) =>
                    uItem.productCFN === existingItem.cfn &&
                    uItem.isUnidRodItem &&
                    uItem.itemBatchAndQty &&
                    uItem.itemBatchAndQty.length > 0
            );
            if (pricedItemIdx >= 0) {
                if (isFromReportScreen && existingItem.isAdditionalCartEntry) {
                    updatedItemObj = {
                        ...pricedItemsArr[pricedItemIdx],
                        cfn: existingItem.cfn,
                        lotSerialNumber: existingItem.lotSerialNumber,
                        accountOwned: existingItem.accountOwned
                            ? existingItem.accountOwned
                            : false,

                        salesOrg: pricedItemsArr[pricedItemIdx].salesOrg,
                        unitPrice: pricedItemsArr[pricedItemIdx].basePrice,
                        usedQuantity:
                            pricedItemsArr[pricedItemIdx].salesOrg === 'S030'
                                ? existingItem.usedQuantity === true ||
                                  parseInt(existingItem.usedQuantity) > 0
                                : existingItem.usedQuantity,
                        otherQuantity:
                            pricedItemsArr[pricedItemIdx].salesOrg === 'S030'
                                ? existingItem.otherQuantity === true ||
                                  (parseInt(existingItem.usedQuantity) > 0
                                      ? false
                                      : parseInt(existingItem.otherQuantity) >
                                        0)
                                : existingItem.otherQuantity,
                        isAdditionalCartEntry:
                            existingItem.isAdditionalCartEntry,
                    };

                    if (existingItem.isUnidRodItem || unidItem?.length > 0) {
                        updatedItemObj.isUnidRodItem = true;
                        updatedItemObj.batchQtyObjArr =
                            existingItem.batchQtyObjArr ||
                            (unidItem && unidItem[0]?.itemBatchAndQty);
                        if (existingItem.isInvalidUnidItemQuantity) {
                            updatedItemObj.isInvalidUnidItemQuantity =
                                existingItem.isInvalidUnidItemQuantity;
                        }
                    }
                    if (existingItem.adjustedUsedQtyPrice) {
                        updatedItemObj.adjustedUsedQtyPrice =
                            existingItem.adjustedUsedQtyPrice;
                    }

                    //cannot have both the value in object
                    if (existingItem.isAdditionalCartEntry) {
                        delete updatedItemObj.otherQuantity;
                    }

                    if (pricedItemsArr[pricedItemIdx].exclusionStatus) {
                        updatedItemObj.isInvalidItemMsg =
                            pricedItemsArr[pricedItemIdx].exclusionStatus ===
                            'Item number not found.'
                                ? invalidProductMsg()
                                : pricedItemsArr[pricedItemIdx].exclusionStatus;
                    }
                    if (existingItem.payment) {
                        updatedItemObj.payment = existingItem.payment;
                    }
                } else if (
                    isFromReportScreen &&
                    !existingItem.isAdditionalCartEntry
                ) {
                    return existingItem;
                } else {
                    updatedItemObj = {
                        ...pricedItemsArr[pricedItemIdx],
                        cfn: existingItem.cfn,
                        lotSerial:
                            pricedItemsArr[pricedItemIdx].salesOrg === 'S030'
                                ? existingItem.lotSerial.map((lotItem) => ({
                                      ...lotItem,
                                      used:
                                          lotItem.used === true ||
                                          parseInt(lotItem.used) > 0,
                                      other:
                                          lotItem.other === true ||
                                          (parseInt(lotItem.used) > 0
                                              ? false
                                              : parseInt(lotItem.other) > 0),
                                  }))
                                : existingItem.lotSerial,
                        accountOwned: existingItem.accountOwned
                            ? existingItem.accountOwned
                            : false,
                        salesOrg: pricedItemsArr[pricedItemIdx].salesOrg,
                        isAdditionalCartEntry:
                            existingItem?.isAdditionalCartEntry
                                ? existingItem.isAdditionalCartEntry
                                : false,
                    };
                    if (existingItem.payment) {
                        updatedItemObj.payment = existingItem.payment;
                    }
                    if (existingItem.isUnidRodItem || unidItem?.length > 0) {
                        updatedItemObj.isUnidRodItem = true;
                        updatedItemObj.batchQtyObjArr =
                            existingItem.batchQtyObjArr ||
                            (unidItem && unidItem[0]?.itemBatchAndQty);
                        if (existingItem.isInvalidUnidItemQuantity) {
                            updatedItemObj.isInvalidUnidItemQuantity =
                                existingItem.isInvalidUnidItemQuantity;
                        }
                    }

                    if (existingItem.isBundleItem) {
                        updatedItemObj.isBundleItem = existingItem.isBundleItem;
                        updatedItemObj.children = existingItem.children;
                    }

                    if (pricedItemsArr[pricedItemIdx].exclusionStatus) {
                        updatedItemObj.isInvalidItemMsg =
                            pricedItemsArr[pricedItemIdx].exclusionStatus ===
                            'Item number not found.'
                                ? invalidProductMsg()
                                : pricedItemsArr[pricedItemIdx].exclusionStatus;
                    } else if (
                        bundleHeadersArr &&
                        bundleHeadersArr.includes(
                            existingItem.cfn.toUpperCase()
                        )
                    ) {
                        if (
                            existingItem.children &&
                            existingItem.children.length > 0
                        ) {
                            // bundle child items validation
                            updatedItemObj.children =
                                getModifiedBundleChildItems(
                                    existingItem,
                                    pricedItemsArr,
                                    bundleHeadersArr
                                );
                        } else {
                            updatedItemObj.noItemInBundleErr = emptyBundleMsg;
                        }
                    } else {
                        updatedItemObj.isInvalidItemMsg = null;

                        if (existingItem.adjustedUsedQtyPrice) {
                            updatedItemObj.adjustedUsedQtyPrice =
                                existingItem.adjustedUsedQtyPrice;
                        }
                        if (existingItem.adjustedOtherQtyPrice) {
                            updatedItemObj.adjustedOtherQtyPrice =
                                existingItem.adjustedOtherQtyPrice;
                        }
                        updatedItemObj.extPrice = getTotalExtendedPrice(
                            pricedItemsArr[pricedItemIdx].basePrice
                                ? pricedItemsArr[pricedItemIdx].basePrice
                                : '',
                            updatedItemObj.lotSerial,
                            'total'
                        );
                        updatedItemObj.otherQtyExtPrice = getTotalExtendedPrice(
                            pricedItemsArr[pricedItemIdx].basePrice
                                ? pricedItemsArr[pricedItemIdx].basePrice
                                : '',
                            updatedItemObj.lotSerial,
                            'other'
                        );
                        updatedItemObj.usedQtyExtPrice = getTotalExtendedPrice(
                            pricedItemsArr[pricedItemIdx].basePrice
                                ? pricedItemsArr[pricedItemIdx].basePrice
                                : '',
                            updatedItemObj.lotSerial,
                            'used'
                        );
                    }
                }
            } else if (existingItem.cfn.toUpperCase().startsWith('SPS')) {
                updatedItemObj.isInvalidItemMsg = invalidSPSitemMsg;
            } else if (
                bundleHeadersArr &&
                bundleHeadersArr.includes(existingItem.cfn) &&
                existingItem.cfn.toUpperCase().startsWith('M1')
            ) {
                updatedItemObj.isInvalidItemMsg = invalidBundleItemMsg;
            } else {
                updatedItemObj.isInvalidItemMsg = invalidProductMsg;
            }
        }
        return updatedItemObj;
    });
};

export const getPriceInNumberDataType = (price) => {
    if (typeof price === 'number') {
        return parseFloat(price);
    }
    if (price) {
        const symbolRemovedPrice = price.replaceAll(/[^\d.,]/g, '');
        const seperators = price.match(/[.,]/g) || [];
        
        let decimalSeperator = '';
        let thousandSeperator = '';
        
        // Check if currency has no decimal places (e.g., JPY, KRW)
        if (numFormatObj.minimumFractionDigits === 0) {
            // For zero-decimal currencies, we need to distinguish between:
            // - Thousands separators: exactly 3 digits after (e.g., "122,845" or "1,234,567")
            // - Decimal separators: 1-2 digits after (e.g., "122845.00") - should be truncated
            if (seperators.length > 0) {
                const lastSeparator = seperators[seperators.length - 1];
                const lastSeparatorIndex = symbolRemovedPrice.lastIndexOf(lastSeparator);
                const digitsAfterLastSeparator = symbolRemovedPrice.substring(lastSeparatorIndex + 1);
                
                // If exactly 3 digits after last separator, it's a thousands separator
                // If 1-2 digits after, it's likely a decimal that should be truncated
                if (digitsAfterLastSeparator.length === 3) {
                    // This is a thousands separator (e.g., "122,845" -> 122845)
                    thousandSeperator = lastSeparator;
                } else if (digitsAfterLastSeparator.length >= 1 && digitsAfterLastSeparator.length <= 2) {
                    // This is a decimal separator (e.g., "122845.00" -> 122845)
                    decimalSeperator = lastSeparator;
                    thousandSeperator = seperators.length > 1 ? seperators[0] : '';
                } else {
                    // All separators are thousands separators
                    thousandSeperator = seperators[0];
                }
            }
        } else if (seperators.length > 0) {
            // Last separator is decimal separator
            decimalSeperator = seperators.pop() || '';
            thousandSeperator = seperators.length > 0 ? seperators[0] : '';
        }

        let numString =
            decimalSeperator !== ''
                ? symbolRemovedPrice
                      .replaceAll(thousandSeperator, '')
                      .replace(decimalSeperator, '.')
                : symbolRemovedPrice.replaceAll(thousandSeperator, '');
        
        // For zero-decimal currencies, truncate any decimal portion
        if (numFormatObj.minimumFractionDigits === 0 && numString.includes('.')) {
            numString = Math.floor(parseFloat(numString)).toString();
        }
        
        return parseFloat(numString);
    }
};

export const getValidateItemsArr = (productsList) => {
    const bundleItems = productsList.filter(
        (item) => item.isBundleItem && item.children && item.children.length > 0
    );
    const bundleItemChildren =
        bundleItems && bundleItems.length > 0
            ? bundleItems.reduce((prev, curr) => prev.concat(curr.children), [])
            : [];
    const bundleChildrenQty = bundleItemChildren.map(
        (child) =>
            child.lotSerial &&
            child.lotSerial.map(
                (i) =>
                    (i.Other || i.other ? Number(i.Other || i.other) : 0) +
                    (i.Used || i.used ? Number(i.Used || i.used) : 0)
            )
    );
    const bundleChildrenLotSerial = bundleItemChildren.map(
        (child) => child.lotSerial && child.lotSerial.map((i) => i.Serial)
    );
    const arrProductCFN = productsList
        .map((item) => item.cfn)
        .concat(bundleItemChildren.map((x) => x.cfn));
    const arrLotSerialNumber = productsList
        .map((item) => item.lotSerial && item.lotSerial.map((i) => i.Serial))
        .concat(bundleChildrenLotSerial);
    const arrQuantity = productsList
        .map(
            (item) =>
                item.lotSerial &&
                item.lotSerial.map(
                    (i) =>
                        (i.Other || i.other ? Number(i.Other || i.other) : 0) +
                        (i.Used || i.used ? Number(i.Used || i.used) : 0)
                )
        )
        .concat(bundleChildrenQty);

    return arrProductCFN.map((cfn, i) => ({
        lotSerialNumber: arrLotSerialNumber[i].toString(),
        productCFN: cfn,
        quantity: arrQuantity[i].toString(),
    }));
};
export const getRPValidateItemsArr = (productsList) => {
    const arrProductCFN = productsList.map(
        (item) => item.cfn || item.productCfn
    );
    const arrQuantity = productsList.map(
        (item) =>
            (item.otherQuantity ? Number(item.otherQuantity) : 0) +
            (item.usedQuantity ? Number(item.usedQuantity) : 0)
    );
    return arrProductCFN.map((cfn, i) => ({
        lotSerialNumber: productsList[i].lotSerialNumber?.toString() || '',
        productCFN: cfn,
        quantity: arrQuantity[i].toString(),
    }));
};

export const getItemTableDataWithQtyValidation = (itemTableData) => {
    return itemTableData.map((item) => {
        let updatedChildrenArr;
        if (item.isBundleItem && item.children && item.children.length > 0) {
            updatedChildrenArr = item.children.map((child) => {
                const updatedChildLotSerialArr = child.lotSerial.map((x) => ({
                    ...x,
                    isInvalidQtyMsg: !checkIfValidQuantities(x)
                        ? t('productValidationMessages.mustEnterUsedQuantity')
                        : null,
                }));
                return {
                    ...child,
                    lotSerial: updatedChildLotSerialArr,
                };
            });
        }
        const updatedLotSerialArr = item.lotSerial.map((x) => ({
            ...x,
            isInvalidQtyMsg:
                !item.isInvalidItemMsg && !checkIfValidQuantities(x)
                    ? item.isBundleItem
                        ? t('productValidationMessages.mustEnterUsedQuantity')
                        : item.salesOrg === 'S030'
                        ? t(
                              'productValidationMessages.mustSelectUsedOrOtherQuantity'
                          )
                        : t(
                              'productValidationMessages.mustEnterUsedOrOtherQuantity'
                          )
                    : null,
        }));

        const itemObj = {
            ...item,
            lotSerial: updatedLotSerialArr,
        };
        if (item.isBundleItem) {
            if (updatedChildrenArr && updatedChildrenArr.length > 0)
                itemObj.children = updatedChildrenArr;
            else itemObj.noItemInBundleErr = emptyBundleMsg;
        }
        return itemObj;
    });
};

export const getValidatedBundleChildren = (
    existingChildren,
    validatedItems
) => {
    const validItemsCFN = validatedItems.map((x) => x.productCFN);
    return existingChildren.map((child) => {
        const isLotSerialReqd =
            validatedItems.filter((val) => child.cfn === val.productCFN)
                .length > 0 &&
            validatedItems.filter(
                (val) =>
                    child.cfn ===
                    Object.prototype.hasOwnProperty.call(val.productCFN)[0],
                'lotSerialData'
            );
        const validatedLotSerialArr =
            isLotSerialReqd &&
            validatedItems.filter((val) => child.cfn === val.productCFN)[0]
                .lotSerialData;

        const updatedLotSerialArr = isLotSerialReqd
            ? child.lotSerial.map((x) =>
                  validatedLotSerialArr.find(
                      (vLot) =>
                          x.Serial &&
                          x.Serial.length > 0 &&
                          vLot.lotSerialNumber === x.Serial &&
                          vLot.statusCode === '10712'
                  )
                      ? {
                            ...x,
                            isInvalidLotSerialMsg:
                                (child.isSerialRequired && !child.isLot) ||
                                child.salesOrg === 'S030'
                                    ? t('equity.common.utils.invalidSerial')
                                    : t('equity.common.utils.invalidLot'),
                        }
                      : validatedLotSerialArr.find(
                            (vLot) =>
                                (!x.Serial ||
                                    (x.Serial && x.Serial.length === 0)) &&
                                vLot.statusCode === '10712'
                        )
                      ? {
                            ...x,
                            isInvalidLotSerialMsg:
                                (child.isSerialRequired && !child.isLot) ||
                                child.salesOrg === 'S030'
                                    ? t('equity.common.utils.serialRequired')
                                    : t('equity.common.utils.lotRequired'),
                        }
                      : { ...x, isInvalidLotSerialMsg: null }
              )
            : child.lotSerial.map((x) => ({
                  ...x,
                  isInvalidLotSerialMsg: null,
              }));

        return {
            ...child,
            isInvalidItemMsg: !validItemsCFN.includes(child.cfn)
                ? invalidProductMsg()
                : null,
            isLotSerialReqd: isLotSerialReqd,
            lotSerial: updatedLotSerialArr,
        };
    });
};

export const getValidatedItemTableData = (existingItems, validatedItems) => {
    const existingItemsWithQtyValidation =
        existingItems?.length > 0 &&
        getItemTableDataWithQtyValidation(existingItems);

    const validItemsCFN = validatedItems.map((x) => x.productCFN);

    return (
        existingItemsWithQtyValidation?.length > 0
            ? existingItemsWithQtyValidation
            : existingItems
    ).map((obj) => {
        const validatedProduct =
            validatedItems.filter((val) => obj.cfn === val.productCFN) &&
            validatedItems.filter((val) => obj.cfn === val.productCFN)[0];

        const isInvalidUnidItemQuantity =
            validatedProduct?.isUnidRodItem &&
            validatedProduct?.statusMessage ===
                t('equity.common.utils.statusmsg');

        const isLotSerialReqd =
            validatedProduct &&
            Object.prototype.hasOwnProperty.call(
                validatedProduct,
                'lotSerialData'
            );

        const validatedLotSerialArr =
            isLotSerialReqd &&
            validatedProduct &&
            validatedProduct.lotSerialData;

        const updatedLotSerialArr = isLotSerialReqd
            ? obj.lotSerial.map((x) =>
                  validatedLotSerialArr.find(
                      (vLot) =>
                          x.Serial &&
                          x.Serial.length > 0 &&
                          vLot.lotSerialNumber === x.Serial &&
                          vLot.statusCode === '10712'
                  )
                      ? {
                            ...x,
                            isInvalidLotSerialMsg:
                                (obj.isSerialRequired && !obj.isLot) ||
                                obj.salesOrg === 'S030'
                                    ? t('equity.common.utils.invalidSerial')
                                    : t('equity.common.utils.invalidLot'),
                        }
                      : validatedLotSerialArr.find(
                            (vLot) =>
                                (!x.Serial ||
                                    (x.Serial && x.Serial.length === 0)) &&
                                vLot.statusCode === '10712'
                        )
                      ? {
                            ...x,
                            isInvalidLotSerialMsg:
                                (obj.isSerialRequired && !obj.isLot) ||
                                obj.salesOrg === 'S030'
                                    ? t('equity.common.utils.serialRequired')
                                    : t('equity.common.utils.lotRequired'),
                        }
                      : { ...x, isInvalidLotSerialMsg: null }
              )
            : obj.lotSerial.map((x) => {
                  //   let totalUnidQty, unidDeliveredQty;
                  //   if (obj.isUnidRodItem && obj.batchQtyObjArr?.length > 0) {
                  //       const batchQtyObj = obj.batchQtyObjArr.filter(
                  //           (b) => b.batch === x.Serial && b.deliveredQty
                  //       );
                  //       if (batchQtyObj && batchQtyObj[0]) {
                  //           unidDeliveredQty = batchQtyObj[0].deliveredQty;
                  //       }
                  //       const usedQty =
                  //           isNaN(x.used) || !x.used ? 0 : parseInt(x.used);
                  //       const otherQty =
                  //           isNaN(x.other) || !x.other ? 0 : parseInt(x.other);
                  //       totalUnidQty = usedQty + otherQty;
                  //   }
                  return {
                      ...x,
                      selectedBatchValue: isInvalidUnidItemQuantity
                          ? x.Serial
                          : null,
                      isInvalidQtyMsg:
                          //   totalUnidQty &&
                          //   unidDeliveredQty &&
                          //   totalUnidQty > parseInt(unidDeliveredQty)
                          isInvalidUnidItemQuantity
                              ? t('reportUsage.itemTableErrorMessages.UnidQty')
                              : x.isInvalidQtyMsg,
                      isInvalidLotSerialMsg: null,
                  };
              });

        const validatedItemObj = {
            ...obj,
            isInvalidItemMsg: !validItemsCFN.includes(obj.cfn)
                ? invalidProductMsg()
                : null,
            isLotSerialReqd: isLotSerialReqd,
            lotSerial: updatedLotSerialArr,
            isInvalidUnidItemQuantity,
        };
        if (validatedProduct && validatedProduct.isUnidRodItem) {
            validatedItemObj.isUnidRodItem = validatedProduct.isUnidRodItem;
        }
        if (obj.isBundleItem && obj.children && obj.children.length > 0) {
            const updatedChildrenArr = getValidatedBundleChildren(
                obj.children,
                validatedItems
            );
            validatedItemObj.children = updatedChildrenArr;
        }
        return validatedItemObj;
    });
};

export const getRPValidatedItemTableData = (existingItems, validatedItems) => {
    const validItemsCFN = validatedItems.map((x) => x.productCFN || x.cfn);
    return existingItems.map((obj) => {
        if (!obj.isAdditionalCartEntry) return obj;
        const isLotSerialReqd =
            validatedItems.filter(
                (val) => (obj.cfn || obj.productCfn) === val.productCFN
            ).length > 0 &&
            validatedItems.filter(
                (val) =>
                    (obj.cfn || obj.productCfn) ===
                    Object.prototype.hasOwnProperty.call(val.productCFN)[0],
                'lotSerialData'
            );
        const validatedLotSerialArr =
            isLotSerialReqd &&
            validatedItems.filter(
                (val) => (obj.cfn || obj.productCfn) === val.productCFN
            )[0].lotSerialData;

        const isInvalidLotSerialMsg = isLotSerialReqd
            ? validatedLotSerialArr.find(
                  (vLot) =>
                      obj.lotSerialNumber &&
                      obj.lotSerialNumber.length > 0 &&
                      vLot.lotSerialNumber === obj.lotSerialNumber &&
                      vLot.statusCode === '10712'
              )
                ? (obj.isSerialRequired && !obj.isLot) ||
                  obj.salesOrg === 'S030'
                    ? t('equity.common.utils.invalidSerial')
                    : t('equity.common.utils.invalidLot')
                : validatedLotSerialArr.find(
                      (vLot) =>
                          (!obj.lotSerialNumber ||
                              (obj.lotSerialNumber &&
                                  obj.lotSerialNumber.length === 0)) &&
                          vLot.statusCode === '10712'
                  )
                ? (obj.isSerialRequired && !obj.isLot) ||
                  obj.salesOrg === 'S030'
                    ? t('equity.common.utils.serialRequired')
                    : t('equity.common.utils.lotRequired')
                : null
            : null;

        const validatedItemObj = {
            ...obj,
            isInvalidItemMsg: !validItemsCFN.includes(obj.cfn || obj.productCFN)
                ? invalidProductMsg()
                : null,
            isLotSerialReqd: isLotSerialReqd,
            isInvalidLotSerialMsg: isInvalidLotSerialMsg,
        };
        // if (obj.isBundleItem && obj.children && obj.children.length > 0) {
        //     const updatedChildrenArr = getValidatedBundleChildren(
        //         obj.children,
        //         validatedItems
        //     );
        //     validatedItemObj.children = updatedChildrenArr;
        // }
        return validatedItemObj;
    });
};

export const getNewItemObj = (
    newItem,
    existingItem,
    isNew,
    bundleHeadersArr
) => {
    const lotSerialArr = [{ used: false, id: getUniqueKey() }];
    let newItemObj = {};
    const itemCFN = newItem.value.toUpperCase();
    if (existingItem.isAdditionalCartEntry) {
        newItemObj = {
            ...existingItem,
            productCFN: itemCFN,
            cfn: itemCFN,
            basePrice: '',
            description: '',
            extPrice: '',
            salesOrg: '',
            uom: '',
            unitPrice: '',
            lotSerialNumber: '',
            usedQuantity: '',
            isInvalidItemMsg:
                existingItem &&
                existingItem.isInvalidItemMsg === invalidProductMsg
                    ? null
                    : existingItem && existingItem.isInvalidItemMsg,
        };
    } else {
        newItemObj = {
            cfn: itemCFN,
            dailyRate: '',
            description: '',
            salesOrg: '',
            uom: '',
            accountOwned: false,
            lotSerial: lotSerialArr,
            otherQtyExtPrice: getTotalExtendedPrice('', lotSerialArr, 'other'),
            usedQtyExtPrice: getTotalExtendedPrice('', lotSerialArr, 'used'),
            extPrice: getTotalExtendedPrice('', lotSerialArr, 'total'),
            isInvalidItemMsg:
                existingItem &&
                existingItem.isInvalidItemMsg === invalidProductMsg
                    ? null
                    : existingItem && existingItem.isInvalidItemMsg,
            isAdditionalCartEntry: false,
        };
    }

    if (newItem.isBundle || bundleHeadersArr?.includes(itemCFN)) {
        newItemObj.isBundleItem = true;
        newItemObj.isBundleFromAddItem = true;
        newItemObj.lotSerial = [
            { used: '1', isInvalidQtyMsg: null, id: getUniqueKey() },
        ];
        newItemObj.isInvalidItemMsg =
            bundleHeadersArr?.includes(itemCFN) && itemCFN.startsWith('M1')
                ? invalidBundleItemMsg()
                : null;
        newItemObj.children = isNew
            ? []
            : existingItem.children &&
              newItemObj.isInvalidItemMsg !== invalidBundleItemMsg
            ? existingItem.children
            : [];
    }
    if (existingItem.payment) {
        newItemObj.payment = existingItem.payment;
    }
    return newItemObj;
};

export const getReplenNonTissueItems = (productsList) => {
    let nonTissueItems = productsList.filter(
        (x) =>
            x.salesOrg !== 'S030' &&
            !x.isBundleItem &&
            !x.isUnidRodItem &&
            x.materialType !== 'DIEN'
    );
    const bundleItems = productsList.filter(
        (item) => item.isBundleItem && item.children && item.children.length > 0
    );
    const bundleChildren =
        bundleItems && bundleItems.length > 0
            ? bundleItems
                  .reduce((prev, curr) => prev.concat(curr.children), [])
                  .filter(
                      (x) =>
                          x.salesOrg !== 'S030' &&
                          !x.isUnidRodItem &&
                          x.materialType !== 'DIEN'
                  )
            : [];
    nonTissueItems = nonTissueItems.concat(bundleChildren);
    return nonTissueItems;
};

export const getValidReplenishGridData = (
    productsList,
    existingReplenData,
    draftOrderReplenItems,
    validatedReplenData
) => {
    const replenItems = [];
    const nonTissueItems = getReplenNonTissueItems(productsList);
    if (nonTissueItems.length > 0) {
        nonTissueItems.forEach((item) => {
            if (!replenItems.map((x) => x.cfn).includes(item.cfn)) {
                let shippingDetails = null;
                const draftRreplenItemIdx =
                    draftOrderReplenItems &&
                    draftOrderReplenItems.findIndex(
                        (data) => data.productCFN === item.cfn
                    );
                if (existingReplenData.map((x) => x.cfn).includes(item.cfn)) {
                    const replenItemIdx = existingReplenData.findIndex(
                        (data) => data.cfn === item.cfn
                    );
                    if (
                        replenItemIdx >= 0 &&
                        existingReplenData[replenItemIdx] &&
                        existingReplenData[replenItemIdx].shippingDetails
                    ) {
                        shippingDetails =
                            existingReplenData[replenItemIdx].shippingDetails;
                    }
                } else if (
                    draftRreplenItemIdx >= 0 &&
                    draftOrderReplenItems[draftRreplenItemIdx] &&
                    draftOrderReplenItems[draftRreplenItemIdx]
                        .replenishmentDetails &&
                    draftOrderReplenItems[draftRreplenItemIdx]
                        .replenishmentDetails.address
                ) {
                    shippingDetails = {
                        accountId: {
                            accountId:
                                draftOrderReplenItems[draftRreplenItemIdx]
                                    .replenishmentDetails.accountId,
                        },
                        shippingAddress: {
                            accountName:
                                draftOrderReplenItems[draftRreplenItemIdx]
                                    .replenishmentDetails.shipToName &&
                                draftOrderReplenItems[
                                    draftRreplenItemIdx
                                ].replenishmentDetails.shipToName
                                    .replace(
                                        draftOrderReplenItems[
                                            draftRreplenItemIdx
                                        ].replenishmentDetails.shipTo,
                                        ''
                                    )
                                    .trim(),
                            addressLine1:
                                draftOrderReplenItems[draftRreplenItemIdx]
                                    .replenishmentDetails.address.line1,
                            city: draftOrderReplenItems[draftRreplenItemIdx]
                                .replenishmentDetails.address.city,
                            postalCode:
                                draftOrderReplenItems[draftRreplenItemIdx]
                                    .replenishmentDetails.address.postalCode,
                            region: draftOrderReplenItems[draftRreplenItemIdx]
                                .replenishmentDetails.address.region,
                            shippingAddressId:
                                draftOrderReplenItems[draftRreplenItemIdx]
                                    .replenishmentDetails.shippingAddressId,
                        },
                        shippingMethod: {
                            shippingMethodId:
                                draftOrderReplenItems[draftRreplenItemIdx]
                                    .replenishmentDetails.shippingMethodId,
                            shippingMethodName:
                                draftOrderReplenItems[draftRreplenItemIdx]
                                    .replenishmentDetails.shippingMethodName,
                        },
                        attnLine: draftOrderReplenItems[draftRreplenItemIdx]
                            .replenishmentDetails.attentionLine
                            ? draftOrderReplenItems[draftRreplenItemIdx]
                                  .replenishmentDetails.attentionLine
                            : '',
                    };
                }
                const validatedItem =
                    validatedReplenData?.length > 0 &&
                    validatedReplenData.find(
                        (vItem) => vItem.productCFN === item.cfn
                    );
                replenItems.push({
                    ...item,
                    isSelected: validatedItem?.isExcluded ? false : true,
                    isExcludedItem: validatedItem?.isExcluded ? true : false,
                    replenQty: getTotalQuantity(item.lotSerial),
                    shippingDetails,
                });
            } else {
                const itemIdx = replenItems.findIndex(
                    (x) => x.cfn === item.cfn
                );
                if (itemIdx >= 0) {
                    replenItems[itemIdx].replenQty = getTotalQuantity([
                        ...replenItems[itemIdx].lotSerial,
                        ...item.lotSerial,
                    ]);
                }
            }
        });
    }
    return replenItems;
};

export const getPriceOverrideTableData = (itemTableData) => {
    const tissueItems = itemTableData.filter(
        (item) => item.salesOrg === 'S030' && !item.accountOwned
    );
    const nonTissueItems = itemTableData.filter(
        (item) => item.salesOrg !== 'S030' && !item.accountOwned
    );
    return [...tissueItems, ...nonTissueItems];
};

export const getUpdatedPriceOverridenData = (
    existingTableData,
    priceOverridenData
) => {
    return existingTableData.map((existingItem) => {
        let updatedItemObj = { ...existingItem };
        const priceOverwrittenItemIdx = priceOverridenData
            .map((x) => x.cfn)
            .findIndex((y) => y === existingItem.cfn);
        if (priceOverwrittenItemIdx >= 0) {
            updatedItemObj = {
                ...priceOverridenData[priceOverwrittenItemIdx],
            };
        }
        return updatedItemObj;
    });
};

export const modifyDraftProductsResponse = (
    existingItems,
    bundleHeadersArr,
    deliveredRodItems
) => {
    const itemTableData = [];
    const bundleChildItems = [];
    existingItems.forEach((item) => {
        if (item.parentCFN) {
            const childItemObj = { ...item, cfn: item.productCFN };
            const childLotSerialObj = {
                used: item.usedQuantity ? item.usedQuantity : false,
            };
            if (item.lotSerialNumber) {
                childLotSerialObj.Serial = item.lotSerialNumber;
            }
            if (item.otherQuantity) {
                childLotSerialObj.other = item.otherQuantity;
            }
            childItemObj.lotSerial = [childLotSerialObj];
            bundleChildItems.push(childItemObj);
        } else {
            if (!itemTableData.map((x) => x.cfn).includes(item.productCFN)) {
                const itemObj = {
                    cfn: item.productCFN,
                    accountOwned: item.isAccountOwned,
                    uom: item.uom,
                    description: item.description,
                    salesOrg: item.salesOrg,
                    isLot: item.isLot,
                    isSerialRequired: item.isSerialRequired,
                };
                const unidItem = deliveredRodItems?.filter(
                    (uItem) =>
                        uItem.productCFN === item.productCFN &&
                        uItem.itemBatchAndQty &&
                        uItem.itemBatchAndQty.length > 0
                );
                itemObj.isUnidRodItem =
                    item.isUnidRodItem ||
                    (unidItem?.length > 0 && unidItem[0]?.isUnidRodItem)
                        ? true
                        : null;
                if (
                    itemObj.isUnidRodItem &&
                    deliveredRodItems?.length > 0 &&
                    unidItem &&
                    unidItem[0]
                ) {
                    itemObj.batchQtyObjArr = unidItem[0].itemBatchAndQty;
                }
                if (
                    bundleHeadersArr &&
                    bundleHeadersArr.includes(item.productCFN) &&
                    (item.productCFN.toUpperCase().startsWith('M2') ||
                        item.productCFN.toUpperCase().startsWith('BUN') ||
                        item.productCFN.toUpperCase().startsWith('KEN') ||
                        item.productCFN.toUpperCase().startsWith('M1'))
                ) {
                    itemObj.isBundleItem = true;
                    itemObj.children = bundleChildItems.filter(
                        (child) => child.parentCFN === item.productCFN
                    );
                }
                if (item.unitPrice) {
                    itemObj.basePrice = setCurrencyFormat(item.unitPrice);
                }
                if (item.description) {
                    itemObj.description = item.description;
                }
                if (item.uom) {
                    itemObj.uom = item.uom;
                }
                const lotSerialObj = { Serial: item.lotSerialNumber };
                if (
                    item.usedQuantity === true ||
                    parseInt(item.usedQuantity) > 0
                ) {
                    lotSerialObj.used =
                        item.salesOrg === 'S030' ? true : item.usedQuantity;
                    if (item.overrideUnitPrice) {
                        itemObj.adjustedUsedQtyPrice = item.overrideUnitPrice;
                    }
                    if (item.payment) {
                        lotSerialObj.usedQtyPayment = item.payment;
                    }
                } else {
                    lotSerialObj.used = false;
                }
                if (
                    item.otherQuantity === true ||
                    parseInt(item.otherQuantity > 0)
                ) {
                    lotSerialObj.other =
                        item.salesOrg === 'S030' ? true : item.otherQuantity;
                    if (item.overrideUnitPrice) {
                        itemObj.adjustedOtherQtyPrice = item.overrideUnitPrice;
                    }
                    if (item.payment) {
                        lotSerialObj.otherQtyPayment = item.payment;
                    }
                }
                itemObj.lotSerial = [lotSerialObj];
                itemObj.extPrice = getTotalExtendedPrice(
                    itemObj.basePrice ? itemObj.basePrice : '',
                    itemObj.lotSerial,
                    'total'
                );
                itemObj.otherQtyExtPrice = getTotalExtendedPrice(
                    itemObj.basePrice ? itemObj.basePrice : '',
                    itemObj.lotSerial,
                    'other'
                );
                itemObj.usedQtyExtPrice = getTotalExtendedPrice(
                    itemObj.basePrice ? itemObj.basePrice : '',
                    itemObj.lotSerial,
                    'used'
                );
                itemTableData.push(itemObj);
            } else {
                const itemIdx = itemTableData.findIndex(
                    (x) => x.cfn === item.productCFN
                );
                if (itemIdx >= 0) {
                    const lotSerialIdx = itemTableData[
                        itemIdx
                    ].lotSerial?.findIndex(
                        (obj) => obj.Serial === item.lotSerialNumber
                    );
                    if (lotSerialIdx >= 0) {
                        if (item.usedQuantity) {
                            if (
                                !itemTableData[itemIdx].lotSerial[lotSerialIdx]
                                    .used
                            ) {
                                itemTableData[itemIdx].lotSerial[
                                    lotSerialIdx
                                ].used = item.usedQuantity;
                            } else {
                                itemTableData[itemIdx].lotSerial[
                                    lotSerialIdx
                                ].used = (
                                    parseInt(
                                        itemTableData[itemIdx].lotSerial[
                                            lotSerialIdx
                                        ].used
                                    ) + parseInt(item.usedQuantity)
                                ).toString();
                            }
                            if (item.payment) {
                                itemTableData[itemIdx].lotSerial[
                                    lotSerialIdx
                                ].usedQtyPayment = item.payment;
                            }
                        }
                        if (item.otherQuantity) {
                            if (
                                !itemTableData[itemIdx].lotSerial[lotSerialIdx]
                                    .other
                            ) {
                                itemTableData[itemIdx].lotSerial[
                                    lotSerialIdx
                                ].other = item.otherQuantity;
                            } else {
                                itemTableData[itemIdx].lotSerial[
                                    lotSerialIdx
                                ].other = (
                                    parseInt(
                                        itemTableData[itemIdx].lotSerial[
                                            lotSerialIdx
                                        ].other
                                    ) + parseInt(item.otherQuantity)
                                ).toString();
                            }
                            if (item.payment) {
                                itemTableData[itemIdx].lotSerial[
                                    lotSerialIdx
                                ].otherQtyPayment = item.payment;
                            }
                        }
                    } else {
                        const nextLotSerialObj = {
                            used: item.usedQuantity ? item.usedQuantity : false,
                        };
                        if (item.usedQuantity && item.payment) {
                            nextLotSerialObj.usedQtyPayment = item.payment;
                        }
                        if (item.otherQuantity) {
                            nextLotSerialObj.other = item.otherQuantity;
                            if (item.payment) {
                                nextLotSerialObj.otherQtyPayment = item.payment;
                            }
                        }
                        if (item.lotSerialNumber) {
                            nextLotSerialObj.Serial = item.lotSerialNumber;
                        }
                        itemTableData[itemIdx].lotSerial.push(nextLotSerialObj);
                    }
                    itemTableData[itemIdx].extPrice = getTotalExtendedPrice(
                        itemTableData[itemIdx].basePrice
                            ? itemTableData[itemIdx].basePrice
                            : '',
                        itemTableData[itemIdx].lotSerial,
                        'total'
                    );
                    itemTableData[itemIdx].otherQtyExtPrice =
                        getTotalExtendedPrice(
                            itemTableData[itemIdx].basePrice
                                ? itemTableData[itemIdx].basePrice
                                : '',
                            itemTableData[itemIdx].lotSerial,
                            'other'
                        );
                    itemTableData[itemIdx].usedQtyExtPrice =
                        getTotalExtendedPrice(
                            itemTableData[itemIdx].basePrice
                                ? itemTableData[itemIdx].basePrice
                                : '',
                            itemTableData[itemIdx].lotSerial,
                            'used'
                        );
                }
            }
        }
    });
    return itemTableData;
};

const getAdditionalProcedureDraftData = (
    draftAddProcedureData,
    additionalProcedureData
) => {
    if (typeof draftAddProcedureData.isMazorXRoboticsUsed === 'boolean') {
        const mazorxRoboticsIdx = additionalProcedureData.findIndex(
            (x) => x.description === t('equity.common.utils.mazorX')
        );
        if (mazorxRoboticsIdx >= 0) {
            additionalProcedureData[mazorxRoboticsIdx].isSelected =
                draftAddProcedureData.isMazorXRoboticsUsed;
            if (draftAddProcedureData.mazorKitCode) {
                additionalProcedureData[mazorxRoboticsIdx].mazorKitCode =
                    draftAddProcedureData.mazorKitCode;
            }
        }
    }
    if (typeof draftAddProcedureData.isNavigaton === 'boolean') {
        const navigationIdx = additionalProcedureData.findIndex(
            (x) => x.description === t('equity.common.utils.navigation')
        );
        if (navigationIdx >= 0) {
            additionalProcedureData[navigationIdx].isSelected =
                draftAddProcedureData.isNavigaton;
        }
    }
    if (typeof draftAddProcedureData.isPowerease === 'boolean') {
        const powereaseIdx = additionalProcedureData.findIndex(
            (x) => x.description === t('equity.common.utils.powerease')
        );
        if (powereaseIdx >= 0) {
            additionalProcedureData[powereaseIdx].isSelected =
                draftAddProcedureData.isPowerease;
        }
    }
    return additionalProcedureData;
};

export const modifyDraftProcedureDataResponse = (
    procedureInfoData,
    draftProcedureData
) => {
    if (
        draftProcedureData.additionProcedure &&
        Object.keys(draftProcedureData.additionProcedure).length > 0 &&
        procedureInfoData.additionalProcedure
    ) {
        procedureInfoData.additionalProcedure = getAdditionalProcedureDraftData(
            draftProcedureData.additionProcedure,
            procedureInfoData.additionalProcedure
        );
    }
    if (
        draftProcedureData.physicianFinderEligibility &&
        draftProcedureData.physicianFinderEligibility.length > 0 &&
        procedureInfoData.therapies
    ) {
        procedureInfoData.therapies = procedureInfoData.therapies.map(
            (phyFinderObj) => ({
                ...phyFinderObj,
                isSelected:
                    draftProcedureData.physicianFinderEligibility.includes(
                        phyFinderObj.code
                    )
                        ? true
                        : null,
            })
        );
    }
    if (
        draftProcedureData.deformityCorrectionCode &&
        draftProcedureData.deformityCorrectionCode.length > 0 &&
        procedureInfoData.technologies
    ) {
        procedureInfoData.technologies = procedureInfoData.technologies.map(
            (deformityObj) => ({
                ...deformityObj,
                isSelected:
                    draftProcedureData.deformityCorrectionCode ===
                    deformityObj.code
                        ? deformityObj.description
                        : null,
            })
        );
    }
    if (
        draftProcedureData.biologicsUsed &&
        draftProcedureData.biologicsUsed.length > 0 &&
        procedureInfoData.biologicsUsed
    ) {
        procedureInfoData.biologicsUsed = procedureInfoData.biologicsUsed.map(
            (bioObj) => ({
                ...bioObj,
                isSelected: draftProcedureData.biologicsUsed.includes(
                    bioObj.code
                )
                    ? true
                    : null,
            })
        );
    }
    if (
        draftProcedureData.medtronicSupp &&
        draftProcedureData.medtronicSupp.length > 0 &&
        procedureInfoData.biologicsDetail
    ) {
        procedureInfoData.biologicsDetail =
            procedureInfoData.biologicsDetail.map((data) => ({
                ...data,
                isMedtronicSelected: draftProcedureData.medtronicSupp.includes(
                    data.code
                )
                    ? true
                    : null,
            }));
    }
    if (
        draftProcedureData.compatitiveSupp &&
        draftProcedureData.compatitiveSupp.length > 0 &&
        procedureInfoData.biologicsDetail
    ) {
        procedureInfoData.biologicsDetail =
            procedureInfoData.biologicsDetail.map((data) => ({
                ...data,
                isCompetitiveSelected:
                    draftProcedureData.compatitiveSupp.includes(data.code)
                        ? true
                        : null,
            }));
    }
    return procedureInfoData;
};

export const getDraftWhyAllRodsNotImplanted = (
    whyAllRodsNotImplanted,
    draftUnidInfo
) => {
    return whyAllRodsNotImplanted.map((item) => {
        const updatedItem = { ...item };
        if (updatedItem.id === 1) {
            updatedItem.isChecked = draftUnidInfo.isSurgeonChangedSurgicalPlan;
        }
        if (updatedItem.id === 2) {
            updatedItem.isChecked = draftUnidInfo.isIssueWithLengthOrContour;
        }
        if (updatedItem.id === 3) {
            updatedItem.isChecked = draftUnidInfo.isSalesOperations;
        }
        if (updatedItem.id === 4) {
            updatedItem.isChecked = draftUnidInfo.isManufacturingIssue;
        }
        if (updatedItem.id === 5) {
            updatedItem.isChecked = draftUnidInfo.isNotDeliveredOnTime;
        }
        if (updatedItem.id === 6) {
            updatedItem.isChecked = draftUnidInfo.isMultipleVersions;
        }
        return updatedItem;
    });
};

export const getDraftWhyNotImplantedAsMainRod = (
    whyNotImplantedAsMainRod,
    draftUnidInfo
) => {
    return whyNotImplantedAsMainRod.map((item) => {
        const updatedItem = { ...item };
        if (updatedItem.id === 1) {
            updatedItem.isChecked = draftUnidInfo.asMainRodSurgicalPlan
                ? draftUnidInfo.asMainRodSurgicalPlan
                : false;
        }
        if (updatedItem.id === 2) {
            updatedItem.isChecked = draftUnidInfo.asMainRodLengthOrContour
                ? draftUnidInfo.asMainRodLengthOrContour
                : false;
        }
        return updatedItem;
    });
};
export const convertDataRpToRecord = (rpDetaiils) => {
    let newArray = [];
    rpDetaiils.map((item) => {
        if (item.isAdditionalCartEntry) {
            let newObject = {
                basePrice: item.basePrice,
                description: item.description,
                isLot: item.isLot,
                isSerialRequired: item.isSerialRequired,
                isSet: item.isSet,
                materialType: item.materialType,
                productCFN: item.productCFN,
                salesOrg: item.salesOrg,
                uom: item.uom,
                cfn: item.cfn,
                lotSerial: [
                    {
                        used:
                            item.salesOrg === 'S030'
                                ? item.usedQuantity === '1'
                                : item.usedQuantity,
                        id: getUniqueKey(),
                        Serial: item.lotSerialNumber,
                        isInvalidQtyMsg: null,
                        other: null,
                    },
                ],
                accountOwned: item.accountOwned,
                isNewProduct: true,
                extPrice: null,
                otherQtyExtPrice: null,
                usedQtyExtPrice: null,
                isInvalidItemMsg: null,
                isAdditionalCartEntry: true,
            };
            if (item.payment) {
                newObject.payment = item.payment;
            }
            newArray.push(newObject);
        }
    });

    return newArray;
};
export const getLotSerialInputPlaceHolder = (item) => {
    if (item.isBundleItem) return 'Not Applicable';
    else if (
        (item.isSerialRequired && !item.isLot) ||
        (item.isSerialRequired && item.isLot && item.salesOrg === 'S030') ||
        (item.isLotSerialReqd && item.salesOrg === 'S030')
    )
        return t('reportUsage.itemList.lotSerialInputPlaceHolder.serialReq');
    else if (
        (item.isLot && item.isSerialRequired) ||
        (item.isLotSerialReqd && item.salesOrg === 'S002')
    )
        return t('reportUsage.itemList.lotSerialInputPlaceHolder.lotReq');
    else if (item.salesOrg === 'S030' && item.isSerialRequired === false)
        return t('reportUsage.itemList.lotSerialInputPlaceHolder.serialOpt');
    else if (
        !item.salesOrg ||
        item.salesOrg === '' ||
        (!Object.prototype.hasOwnProperty.call(item, 'isSerialRequired') &&
            !Object.prototype.hasOwnProperty.call(item, 'isLot'))
    )
        return t('reportUsage.itemList.lotSerialInputPlaceHolder.lotOrSerial');
    else return t('reportUsage.itemList.lotSerialInputPlaceHolder.lotOpt');
};
